import { render, staticRenderFns } from "./NextBuyCashbackOfferSale.vue?vue&type=template&id=640ed238"
import script from "./NextBuyCashbackOfferSale.vue?vue&type=script&lang=js"
export * from "./NextBuyCashbackOfferSale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports